jQuery (function () {
    var productType = '';
    var productSize = '';
    var productPrice = '';
    var productInterval = '';

    // Radio Button function
    jQuery ('.crc-subscription-section__item').on ('click', function () {
        // get group name
        var group = jQuery (this).data ('group');
        
        // remove selected class from all members of the group
        jQuery ('.crc-subscription-section__item[data-group=' + group + ']').removeClass ('selected-item');
        
        // add selected class to selected item
        jQuery (this).addClass ('selected-item');
       
    });

    // Step 1: Personal or Gift
    jQuery ('.subscription-type').on ('click', function () {
    // Reset options //

        // hide all the sections except the first section
        jQuery ('.crc-subscription-section__step-2, .crc-subscription-section__step-3, .crc-subscription-section__step-4, .crc-subscription-section__summary').addClass ('hide-section');

        // hide all buttons
        jQuery ('.crc-subscription-section__summary-add-to-cart-buttons li').addClass ('hide-button');

        // Remove all the selected states from interal options except from the first section
        jQuery ('.crc-subscription-section__step-2 .crc-subscription-section__item, crc-subscription-section__step-3 .crc-subscription-section__item').removeClass ('selected-item');
        
        // Hide all the interval options
        jQuery ('.subscription-intervals').addClass ('hide-options');

        // Show any hidden bag sizes
        jQuery ('.subscription-bag-size[data-bag-size=2-lb]').show ();
        jQuery ('.subscription-bag-size[data-bag-size=5-lb]').show ();

    // Set options //
        productType = jQuery (this).data ('type');

        // Show the options that relate to the selected subscription type
        jQuery ('.subscription-intervals[data-type=' + productType + ']').removeClass ('hide-options');

        // Show next section
        jQuery ('.crc-subscription-section__step-2').removeClass ('hide-section');
    });

    // Step 2: Coffee Selection
    jQuery ('.subscription-product').on ('click', function () {
        // Rest interval and summary stage
        jQuery ('.crc-subscription-section__step-4, .crc-subscription-section__step-3, .crc-subscription-section__summary').addClass ('hide-section');

        // hide all buttons
        jQuery ('.crc-subscription-section__summary-add-to-cart-buttons li').addClass ('hide-button');

        // Remove all the selected states from interal options except from the first section
        jQuery ('.crc-subscription-section__step-4 .crc-subscription-section__item').removeClass ('selected-item');

        // Show next section
        if (productType == 'gift') {
            jQuery ('.subscription-bag-size[data-bag-size=2-lb]').hide ();
            jQuery ('.subscription-bag-size[data-bag-size=5-lb]').hide ();
        }
        jQuery ('.crc-subscription-section__step-4').removeClass ('hide-section');
    });

    // Step 3: Bag Size
    jQuery ('.subscription-bag-size').on ('click', function () {
        // Reset options //
        jQuery ('.crc-subscription-section__step-3, .crc-subscription-section__summary').addClass ('hide-section');
        
        // hide all buttons
        jQuery ('.crc-subscription-section__summary-add-to-cart-buttons li').addClass ('hide-button');

        // Remove all the selected states from interal options except from the first section
        jQuery ('.crc-subscription-section__step-3 .crc-subscription-section__item').removeClass ('selected-item');

        // Setup prices for next step
        productSize = jQuery (this).data ('bagSize');

        jQuery ('.subscription-intervals[data-type=' + productType + '] .crc-subscription-section__item.subscription-interval').each (function () {

            if (productSize == '12-oz')
                productPrice = jQuery (this).data ('price-12ozDisplay');
            
            if (productSize == '2-lbs')
                productPrice = jQuery (this).data ('price-2lbDisplay');
            
            if (productSize == '5-lbs')
                productPrice = jQuery (this).data ('price-5lbDisplay');
            
            jQuery (this).find ('.display-price').text (productPrice);
        });

        // Show next section
        jQuery ('.crc-subscription-section__step-3').removeClass ('hide-section');
    });

    // Step 4: Interval
    jQuery ('.subscription-interval').on ('click', function () {
        // Reset Summary Stage
        jQuery ('.crc-subscription-section__summary-add-to-cart-buttons li').addClass ('hide-button');

        // Set summary from selected items
        var type        = jQuery ('.subscription-type.selected-item').data ('type');
        var typeDisplay = jQuery ('.subscription-type.selected-item').data ('typeDisplay');

        var descDisplay = jQuery ('.subscription-product.selected-item').data ('desc');

        var product         = jQuery ('.subscription-product.selected-item').data ('product');
        var productDisplay  = jQuery ('.subscription-product.selected-item').data ('productDisplay');

        var bagSize         = jQuery ('.subscription-bag-size.selected-item').data ('bagSize');
        var bagSizeDisplay  = jQuery ('.subscription-bag-size.selected-item').data ('bagSizeDisplay');

        var interval        = jQuery ('.subscription-interval.selected-item').data ('interval');
        var intervalDisplay = jQuery ('.subscription-interval.selected-item').data ('intervalDisplay');

        if (type == 'gift') intervalDisplay = 'for ' + intervalDisplay;

        // Build selector
        var summarySelector = 'li[data-type=' + type + '][data-product=' + product + '][data-interval=' + interval + '][data-bag-size=' + bagSize + ']';

        var price   = jQuery (summarySelector).data ('price');
        
        // Set values on summary card
        jQuery ('.crc-subscription-section__summary-plan').text (typeDisplay);
        jQuery ('.crc-subscription-section__summary-interval').text (intervalDisplay);
        jQuery ('.crc-subscription-section__summary-product-title').text (productDisplay);
        jQuery ('.crc-subscription-section__summary-description').text (descDisplay);
        jQuery ('.crc-subscription-section__summary-bag-size').text (bagSizeDisplay);
        jQuery ('.crc-subscription-section__summary-summary').text (price + " " + intervalDisplay + " + Shipping");

        // Unhide add to cart button
        jQuery (summarySelector).removeClass ('hide-button');
       
        // Show summary
        jQuery ('.crc-subscription-section__summary').removeClass ('hide-section');
    });


    jQuery ('.quick-add-button').on ('click', function () {
        jQuery (this).parent ().parent ().find ('.quick-add-drawer').toggleClass ('show');

        return false;
    });

    jQuery ('.quick-add-overlay').on ('click', function () {
        jQuery (this).parent ().toggleClass ('show');

        return false;
    });
});